import { render } from "./NotesList.vue?vue&type=template&id=ed3b4d9c&scoped=true"
import script from "./NotesList.vue?vue&type=script&lang=js"
export * from "./NotesList.vue?vue&type=script&lang=js"

import "./NotesList.vue?vue&type=style&index=0&id=ed3b4d9c&lang=scss"
import "./NotesList.vue?vue&type=style&index=1&id=ed3b4d9c&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed3b4d9c"]])

export default __exports__